<div class="nav-container">
  <nav>
    @for (tab of tabs; track tab) {
      <a (click)="selectTab(tab)" [class.active]="tab.active | async" [attr.data-test-id]="'gbc-tab-nav-' + tab.name">{{tab.title}}</a>
    }
  </nav>
</div>
<ng-content></ng-content>
